import React, { memo, useMemo } from 'react';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import UserList from './UserList';
import { UserStatsContainer } from './UserStats';

const styles = {
	Container: {
		display: 'flex',
		flexDirection: 'row',
	},
	UsersPaper: {
		width: '250px',
		padding: '16px',
	},
	ArticlesPaper: {
		flex: 1,
		marginLeft: '20px',
		padding: '20px',
	},
};

const Stats = memo(props => {
	const { userId, page, users = [], handleClick, handleChangePage, handleBlockedClick } = props;
	const [filterText, setFilterText] = React.useState('');

	const user = useMemo(() => {
		if (userId) {
			return users.find(edge => edge.node._id === userId).node;
		}
		return undefined;
	}, [users, userId]);

	const sortedUsers = useMemo(() => {
		return [...users]
			.filter(user =>
				user.node.name.toLowerCase().includes(filterText.toLowerCase())
			)
			.sort((a, b) => a.node.name.localeCompare(b.node.name));
	}, [users, filterText]);

	return (
		<div style={styles.Container}>
			<Paper style={styles.UsersPaper}>
				<TextField
					fullWidth
					hintText="Поиск пользователей..."
					value={filterText}
					onChange={(_, v) => setFilterText(v)}
				/>
				<UserList userId={userId} onChange={handleClick} users={sortedUsers} />
			</Paper>
			<Paper style={styles.ArticlesPaper}>
				{typeof user === 'undefined' ? (
					<h3>Выберите пользователя</h3>
				) : (
					<UserStatsContainer
						page={page}
						user={user}
						userId={userId}
						handleChangePage={handleChangePage}
						onToggleBlocked={handleBlockedClick}
					/>
				)}
			</Paper>
		</div>
	);
});

export default Stats;



// WEBPACK FOOTER //
// src/components/stats/Stats.js